import React from "react";
import PropTypes from "prop-types";
import { AlertCircle, Tooltip } from "@opendate-app/setlist";

const FilterErrorIcon = ({ errors }) => {
  if (!errors.length) return null;
  const message = errors.join(" ");
  return (
    <Tooltip title="Filter error" supportingText={message}>
      <AlertCircle
        tabIndex={0}
        role="img"
        aria-label="Filter error"
        width="1em"
        height="1em"
        style={{ color: "var(--sl-text-error)", flex: "0 0 auto" }}
      />
    </Tooltip>
  );
};

FilterErrorIcon.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default FilterErrorIcon;
